import { useNavigate } from "react-router-dom";

import { ROUTE_PATHS } from "@routes/routePath";

interface Args {
  draftArticleId: string;
  publicationNumber: string | null;
}

export const useMovePatentDetailPage = ({
  draftArticleId,
  publicationNumber,
}: Args) => {
  const navigate = useNavigate();

  const movePatentDetailPage = () => {
    const pathname = ROUTE_PATHS.patentFillInTable;
    const url = `${pathname}?id=${draftArticleId}&publicationNumber=${publicationNumber}`;

    navigate(url);
  };

  return {
    movePatentDetailPage,
  };
};
